import { useTips, useDoubleSidebar, useGlobal } from "@vojomo-core/shared";
import React, { useMemo, useState } from "react";
import styled from "styled-components";

export const TipViewer: React.FC<{
  tipId: string;
}> = ({ tipId }) => {
  const { windowWidth } = useGlobal();
  const [isHidden, setIsHidden] = useState<boolean>(false);

  const { ignoreTipForever, ignoreTipSession, isTipIgnored } = useTips();

  const { isCollapsed } = useDoubleSidebar();

  const bubbleWidth = useMemo(
    () => (!isCollapsed && windowWidth < 1600 ? "200px" : "360px"),
    [windowWidth, isCollapsed]
  );

  if (isTipIgnored(tipId) || isHidden) {
    return <></>;
  }

  return (
    <Wrap>
      <Close
        onClick={() => {
          setIsHidden(true);
          ignoreTipSession(tipId);
        }}
        aria-label="Close"
      >
        x
      </Close>

      <Bubble style={{ maxWidth: bubbleWidth }}>
        <Text>
          Title your document above and select your doc type, so Vo can shape
          your guidance. {/* <A href="#">Want Vo to Explain the value?</A> */}
        </Text>
      </Bubble>

      <DontShow
        onClick={() => {
          setIsHidden(true);
          ignoreTipForever(tipId);
        }}
      >
        don't show again
      </DontShow>
    </Wrap>
  );
};

const Wrap = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

const Close = styled.button`
  position: absolute;
  top: 8px; /* inside the bubble */
  right: 12px;
  border: none;
  background: none;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  color: #000000b3;

  &:hover {
    color: #000;
  }
`;

const Bubble = styled.div`
  background: #e6f0ff; /* light blue */
  border: 1px solid #d2e2ff; /* subtle border */
  border-radius: 14px; /* pillish corners like screenshot */
  padding: 14px 16px;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.02) inset;
  max-width: 360px;
`;

const Text = styled.div`
  font-family:
    system-ui,
    -apple-system,
    "Segoe UI",
    Roboto,
    sans-serif;
  font-size: 14px;
  color: #1f2937;
  line-height: 1.35;
`;

// const A = styled.a`
//   color: #1d4ed8;
//   text-decoration: underline;
//   cursor: pointer;
// `;

const DontShow = styled.button`
  align-self: flex-end; /* right-aligned below bubble */
  margin-top: 8px;
  border: none;
  background: none;
  font-size: 12px;
  color: #6b7280;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;
